var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavingPrevYearIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 8,
    viewBox: "0 0 4 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.81271 0.250014C2.86743 0.18164 2.93508 0.124712 3.0118 0.0824808C3.08852 0.0402501 3.1728 0.0135437 3.25984 0.0038864C3.43562 -0.0156174 3.61196 0.0355076 3.75005 0.146014C3.88814 0.256521 3.97667 0.417358 3.99617 0.593142C4.01568 0.768926 3.96455 0.945258 3.85405 1.08335L1.52071 4.00001L3.85405 6.91668C3.96455 7.05477 4.01568 7.2311 3.99617 7.40689C3.97667 7.58267 3.88814 7.74351 3.75005 7.85401C3.61196 7.96452 3.43562 8.01565 3.25984 7.99614C3.08406 7.97664 2.92322 7.8881 2.81271 7.75001L0.146046 4.41668C0.0513773 4.29844 -0.000203609 4.15148 -0.000203609 4.00001C-0.000203609 3.84854 0.0513773 3.70159 0.146046 3.58335L2.81271 0.250014Z",
    fill: "#797B80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingPrevYearIcon);
export default __webpack_public_path__ + "static/media/savingPrevYearIcon.37153f903470d6531d87e11117e3c89a.svg";
export { ForwardRef as ReactComponent };